import { toJSONWithExtras, reviveWithProto } from "./revive"

import { DraftSyncItem } from "@/shared/sync/dataTypes/DraftSyncItem"
import { DraftSyncVersion } from "@/shared/sync/dataTypes/DraftSyncVersion"

export function serializeSyncItem(item: DraftSyncItem) {
  const out: any = {
    draftId: (item as any).draftId,
    _local: toJSONWithExtras((item as any)._local),
    _mostUpdatedVersion: toJSONWithExtras((item as any)._mostUpdatedVersion),
    _deviceCloudVersion: toJSONWithExtras((item as any)._deviceCloudVersion),
    mostUpdatedVersionBeforeMerge: toJSONWithExtras((item as any).mostUpdatedVersionBeforeMerge),
    deviceCloudVersionBeforeMerge: toJSONWithExtras((item as any).deviceCloudVersionBeforeMerge),
    syncVersionsByDevice: Object.fromEntries(
      Object.entries((item as any).syncVersionsByDevice ?? {}).map(([k, v]: any) => [
        k,
        toJSONWithExtras(v),
      ])
    ),
  }
  return out
}

export function deserializeSyncItem(raw: any): DraftSyncItem {
  const obj = typeof raw === 'string' ? JSON.parse(raw) : raw

  // Seed invariants: map object + non-enumerable delegate
  const item = reviveWithProto(DraftSyncItem, obj, inst => {
    inst.syncVersionsByDevice = inst.syncVersionsByDevice ?? {}
    Object.defineProperty(inst, 'delegate', {
      enumerable: false,
      writable: true,
      configurable: true,
      value: undefined,
    })
  })

  // Deep-revive DraftSyncVersion fields (no method lists required)
  const reviveV = (v: any) => (v ? DraftSyncVersion.fromJSON(v) : undefined)

  ;(item as any)._local = reviveV(obj._local)
  ;(item as any)._mostUpdatedVersion = reviveV(obj._mostUpdatedVersion)
  ;(item as any)._deviceCloudVersion = reviveV(obj._deviceCloudVersion)
  ;(item as any).mostUpdatedVersionBeforeMerge = reviveV(obj.mostUpdatedVersionBeforeMerge)
  ;(item as any).deviceCloudVersionBeforeMerge = reviveV(obj.deviceCloudVersionBeforeMerge)

  const byDevice: Record<string, any> = obj?.syncVersionsByDevice ?? {}
  ;(item as any).syncVersionsByDevice = Object.fromEntries(
    Object.entries(byDevice).map(([k, v]) => [k, reviveV(v)])
  )

  return item
}
